import { defineComponent } from "vue";
import HomeListTitle from "./homeListTitle.vue";
import MvList from "@/components/mv-list/mvList.vue";
export default defineComponent({
  name: "alonePlay",
  props: {
    aloneList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup() {
    return {};
  },
  components: {
    HomeListTitle: HomeListTitle,
    MvList: MvList
  }
});